import { Component, Inject, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { finalize } from 'rxjs/operators';
import { SharedModule } from '../../../../shared/shared.module';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogModule as MatDialogModule, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { BankAccountPropertiesComponent } from '../bank-account-properties/bank-account-properties.component';
import { GrowlerService } from '../../../../shared/growler/growler.service';
import { BankAccountsService } from '../../../../../services/financial-accounts/bank-accounts.service';
import { ValidationMessageService } from '../../../../../services/validation-message.service';

export interface AddOrgBankAccountDialogInput
{
    onlyDepositAccounts?: boolean;
}

export interface AddOrgBankAccountDialogResult
{
    success: boolean;
}

@UntilDestroy()
@Component({
    selector: 'app-add-org-bank-account-dialog',
    templateUrl: './add-org-bank-account-dialog.component.html',
    standalone: true,
    imports: [
        SharedModule,
        MatButtonModule,
        MatIconModule,
        MatSlideToggleModule,
        MatDialogModule,
        MatExpansionModule,
        MatSelectModule,
        BankAccountPropertiesComponent,
    ],
})
export class AddOrgBankAccountDialogComponent
{
    @ViewChild('propertiesForm') propertiesForm: BankAccountPropertiesComponent;

    isSaving = false;

    constructor(
            private _bankAccountsService: BankAccountsService,
            private _dialogRef: MatDialogRef<AddOrgBankAccountDialogComponent>,
            private _growler: GrowlerService,
            private _validationMessageService: ValidationMessageService,
            @Inject(MAT_DIALOG_DATA) public data: AddOrgBankAccountDialogInput,
    ) {
    }

    saveAccount() {
        if (!this.propertiesForm.isValid()) {
            return;
        }

        const request = this.propertiesForm.getFormValue();

        this.isSaving = true;
        this._bankAccountsService.createOrganizationBankAccount(
                null,
                request,
        ).pipe(
                finalize(() => this.isSaving = false),
                untilDestroyed(this),
        ).subscribe({
            next: () => {
                this._dialogRef.close(<AddOrgBankAccountDialogResult>{
                    success: true,
                });
                this._growler.success('Success', 'We have successfully added your bank account');
            },
            error: (error) => {
                this._growler.oops(this._validationMessageService.extractResponseErrorText(error));
            },
        });
    }

    closeDialog() {
        this._dialogRef.close(<AddOrgBankAccountDialogResult>{success: false});
    }
}
